import { render, staticRenderFns } from "./ROITableStorefront.vue?vue&type=template&id=210edcbd&scoped=true&"
import script from "./ROITableStorefront.vue?vue&type=script&lang=js&"
export * from "./ROITableStorefront.vue?vue&type=script&lang=js&"
import style0 from "./ROITableStorefront.vue?vue&type=style&index=0&id=210edcbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210edcbd",
  null
  
)

export default component.exports